// @flow

import React from 'react';
import { Query } from 'react-apollo';
import { connect } from 'react-redux';
import { featureIsEnabled } from '@ta/common.features';

import SponsoredDmoItemsQuery from './SponsoredDmoItemsQuery.gql';
import SponsoredDmoContentModule from './SponsoredDmoContentModule';

type ExternalProps = {||};

type Props = {|
  ...ExternalProps,
  locationId: number,
|};

/**
 * Is this a valid sponsorship (profile with photo, shelf is enabled)
 * @param sponsorship
 */
const isValidSponsorship = (sponsorship?: any): boolean => {
  if (!sponsorship) {
    return false;
  }
  const { userProfile, items } = sponsorship;
  // must have at least one item
  if (!items.length) {
    return false;
  }
  // must have a userProfile
  if (!userProfile) {
    return false;
  }
  const item = sponsorship?.items?.[0];
  // If item is a linkpost but doesn't have an image, fail.
  if (item.type === 'LINK_POST' && !item?.object?.preview?.media?.[0]) {
    return false;
  }
  return true;
};

/* Queries to check if a DMO is sponsoring this page, in which case we should display a sponsored card. */
const SponsoredDmoModule = ({ locationId }: Props) => {
  if (!featureIsEnabled('sponsored_dmo_right_rail_module')) {
    return null;
  }
  return (
    <Query query={SponsoredDmoItemsQuery} variables={{ locationId }}>
      {({ data, loading }) => {
        const sponsorshipData =
          data && data.locations && data.locations[0] && data.locations[0].dmoItems;
        if (!loading && sponsorshipData && isValidSponsorship(sponsorshipData)) {
          return <SponsoredDmoContentModule sponsorshipData={sponsorshipData} />;
        }
        return null;
      }}
    </Query>
  );
};

export default connect<Props, ExternalProps, _, _, _, _>(state => ({
  locationId: state.route.geo,
}))(SponsoredDmoModule);
